<template>
	<sideNav :page-title="pageTitle"></sideNav>
	<div v-show="showFlag">
		<div class="ld-panel-title">
			<router-link to="/verify" class="back-btn"><span></span>个人认证</router-link>
		</div>
		<div class="ld-panel-main">
			<el-steps :active="1" finish-status="success" simple style="margin-bottom: 30px;">
			    <el-step title="填写认证资料" />
			    <el-step title="认证信息校验" />
			</el-steps>
			<el-form :label-width="formLabelWidth">
				<el-form-item label="个人认证类型">
					<el-radio-group v-model="auth_type" @change="wayChange">
						<el-radio label="5" border>个人支付宝扫脸授权认证</el-radio>
						<el-radio label="11" border>微信扫脸认证</el-radio>
						<el-radio label="3" border>手机号码 验证实名</el-radio>
						<el-radio label="6" border>个人支付宝扫描身份证认证</el-radio>
					</el-radio-group>
				</el-form-item>
				<div v-if="auth_type == '3'">
					<el-form-item label="手机号码">
						<el-input v-model="mobile" disabled autocomplete="off" />
						<router-link to="/account/mobile" style="margin-left: 10px;">修改</router-link>
					</el-form-item>
					<p class="form-tip" style="margin-left: 160px;">请确认该手机号是您本人所有，否则无法验证通过，将产生额外认证费用！<el-text type="warning">{{tipText}}</el-text></p>
				</div>
				<el-form-item label="身份验证" v-else>
					<div>
						为了认证您的身份<el-text type="primary">（{{authName}}）</el-text>，请用<el-text type="warning"> {{auth_text}} </el-text>扫描二维码
						<div class="ewm">
							<el-image :src="'data:image/png;base64,'+codeImg" style="width: 160px;"></el-image>
							<h5>系统将自动审核，并实时反馈审核结果</h5>
						</div>
					</div>
				</el-form-item>
				<el-form-item>
					<el-button @click="btnBack">上一步</el-button>
					<el-button type="primary" @click="btnCheck" v-if="auth_type == '3'">提交</el-button>
				</el-form-item>
			</el-form>
			<div class="foot-warn" style="margin-top: 60px;">
				<h4 class="title">温馨提示：</h4>
				<div class="content">
					<p>1. 每账号有1次免费手机号码认证机会，最多有5次认证机会（超出费用 按每次 1.50 元收认证手续费，认证费用用于支付三大运营商及银联实名认证接口费用），次数用尽则该账号无法继续认证</p>
					<p>2. 蓝队云工作人员不会向您索要短信验证码，请勿向任何人泄露</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
	import { ref,onBeforeUnmount,onMounted} from 'vue';
	import Cookies from 'js-cookie';
	import { useRouter } from 'vue-router';
	import { authStatusF,authInfo,mobileStatus,mobileverify,perFaceAlipay,perFaceTencent,perAuthAlipay } from '@/api/auth';
	import sideNav from '../../components/sideNav.vue';
	import { ElMessage } from 'element-plus';
	
	const pageTitle = 'account';
	const router = useRouter();
	const showFlag = ref(false);
	const formLabelWidth = ref('160px');
	const authName = ref('');
	const auth_type = ref('5');
	const auth_text= ref('支付宝');
	const codeImg = ref('');
	const mobile = Cookies.get('LDMOBILE');
	const tipText = ref('');
	const outerOrder = ref('');
	let timerId = null;
	
	const generData = () => {
		authInfo().then((res) => {
			if(res.code === 200){
				if (res.data.authStatus == '1') {
					router.push({ path: '/verify/success' })
				}else{
					authName.value = res.data.authName
					showFlag.value = true
					perFaceAlipayF()
				}
			}
		})
	};
	const authF = () => {
		authStatusF(outerOrder.value).then((res) => {
			if(res.code === 200 && res.data.status == '1'){
				clearInterval(timerId);
				router.push({ path: '/verify/success' })
			}
		})
	}
	const wayChange = (e) => {
		clearInterval(timerId);
		switch(e)
		{
			case '5':
				auth_text.value = '支付宝';
				perFaceAlipayF()
			break;
			case '11':
				auth_text.value = '微信';
				perFaceTencentF()
			break;
			case '6':
				auth_text.value = '支付宝';
				perAuthAlipayF()
			break;
			case '3':
				mobileF()
			break;
		}
	};
	const mobileF = () => {
		mobileStatus().then((res) => {
			if(res.code === 200){
				tipText.value = res.data.mobileVerifyTips
			}
		})
	}
	const perFaceAlipayF = () => {
		perFaceAlipay().then((res) => {
			if(res.code === 200){
				codeImg.value = res.data.qrcode;
				outerOrder.value = res.data.outer_order_no;
				timerId = setInterval(authF, 3000);
			}
		})
	};
	const perFaceTencentF = () => {
		perFaceTencent().then((res) => {
			if(res.code === 200){
				codeImg.value = res.data.qrcode;
				outerOrder.value = res.data.outer_order_no;
				timerId = setInterval(authF, 3000);
			}
		})
	};
	const perAuthAlipayF = () => {
		perAuthAlipay().then((res) => {
			if(res.code === 200){
				codeImg.value = res.data.qrcode;
				outerOrder.value = res.data.outer_order_no;
				timerId = setInterval(authF, 3000);
			}
		})
	};
	const btnCheck = () => {
		mobileverify().then((res) => {
			if(res.code === 200 && res.data.authStatus == 1){
				ElMessage({
					offset:70,
					message: res.msg,
					type: 'success'
				})
				router.push({ path: '/verify/success' })
			}
		})
	}
	const btnBack = () => {
		router.push({ path: '/verify/person' })
	};
	
	onMounted(() => {
		generData()
	})
	onBeforeUnmount(() => {
	  clearInterval(timerId); 
	});
</script>

<style scoped>
	.ewm{padding-top: 20px; text-align: center; width: 200px; overflow: hidden;}
</style>